import type { LeadStatus } from '@360t/shared';

const STATUSES: LeadStatus[] = ['new', 'contacted', 'replied', 'won', 'lost'];

const TONE: Record<LeadStatus, string> = {
  new: 'border-line text-slate-600',
  contacted: 'border-accent/40 text-accent',
  replied: 'border-brand/50 text-brand-dark',
  won: 'border-good/50 text-good',
  lost: 'border-line text-slate-400',
};

export function StatusSelect({
  value,
  onChange,
  disabled,
}: {
  value: LeadStatus;
  onChange: (next: LeadStatus) => void;
  disabled?: boolean;
}) {
  return (
    <select
      className={`rounded-md border bg-white px-2 py-1 text-xs font-semibold capitalize outline-none ${TONE[value]}`}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as LeadStatus)}
    >
      {STATUSES.map((s) => (
        <option key={s} value={s}>
          {s}
        </option>
      ))}
    </select>
  );
}
